module.exports = __webpack_public_path__ + "img/Strip-Front-B2-Cb-Jb.41f6d5b2.png";